import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, {
    name: _ctx.name,
    clearable: _ctx.clearable,
    label: _ctx.label,
    type: _ctx.type === 'password' ? (_ctx.isPwd ? 'text' : 'password') : _ctx.type,
    error: _ctx.error,
    placeholder: _ctx.placeholder
  }, _createSlots({
    error: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
    ]),
    _: 2
  }, [
    (_ctx.icon)
      ? {
          name: "append",
          fn: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: _ctx.icon,
              color: "secondary"
            }, null, 8, ["name"])
          ])
        }
      : (_ctx.type === 'password')
        ? {
            name: "append",
            fn: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: _ctx.isPwd ? 'visibility_off' : 'visibility',
                class: "cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isPwd = !_ctx.isPwd))
              }, null, 8, ["name"])
            ])
          }
        : undefined
  ]), 1032, ["name", "clearable", "label", "type", "error", "placeholder"]))
}